import { sendRequest } from "../sendRequest";

export const getEarnings = () => {
  const queryKey = ["wallet", "earnings"];
  const queryFunction = ({ pageParam }) =>
    sendRequest(
      "get",
      `/influencer/wallet/earnings/tnx?limit=20${
        pageParam ? `&nextPageToken=${pageParam}` : ""
      }`
    ).then((res) => res.data);
  return { queryKey, queryFunction };
};
